import * as React from 'react'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import GppGoodIcon from '@mui/icons-material/GppGood'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const VendorFrontPageOpenRfpCard: React.FC<{ rfp: VendorUserRequestForProposal }> = ({ rfp }) => {
  const { t } = useTranslation()
  
  const isLocked = rfp.rfpProposalViewingLockedUntilDueDate === true

  return (
    <Card sx={{ border: '1px solid #E5E7EB', position: 'relative', overflow: 'visible' }}>
      {isLocked && (
        <Tooltip title={t('request-for-proposal-proposal-viewing-locked')}>
          <Box
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <GppGoodIcon sx={{ color: 'primary.main', fontSize: 24 }} />
          </Box>
        </Tooltip>
      )}
      <CardContent
        sx={{
          position: 'relative',
          ...(isLocked && {
            pr: { xs: 7, sm: 3 }
          })
        }}
      >
        <Typography sx={{ fontSize: 14 }} color="text.secondary">
          {`${rfp.buyerName} (${rfp.tenantName})`}
        </Typography>
        <Typography sx={{ fontSize: 16, fontWeight: 'fontWeightMedium', mb: 1 }}>{rfp.rfpTitle}</Typography>
        <Typography sx={{ fontSize: 14 }} color="error">
          {`${t('due-date-is')} ${rfp.proposalDueDateDisplay}`}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          sx={{ color: 'common.white', ml: 1, mb: 1 }}
          variant="contained"
          component={Link}
          to={`/${rfp.uniqueToken}`}
          state={{ from: '/vendors' }}
        >
          {t('submit-proposal')}
        </Button>
      </CardActions>
    </Card>
  )
}

export default VendorFrontPageOpenRfpCard
